import "./FindAddArcOperatorStation.html";
import "./FindArcOperatorStationResultTemplate.html";

import type { IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import FindAddArcOperatorStationComponentController from "./FindAddArcOperatorStationComponentController";

export class FindAddArcOperatorStationComponent implements ng.IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    public transclude: boolean;

    constructor() {
        this.bindings = {
            canAddOperatorStation: "<",
            clearAfterAdd: "<",
            hideTitle: "<",
            newOperatorStation: "&?",
            partnerId: "<",
            removeFromResult: "<",
            selectOperatorStation: "&?",
        };
        this.controller = FindAddArcOperatorStationComponentController;
        this.templateUrl = "/App/Components/Forms/FindAddArcOperatorStation/FindAddArcOperatorStation.html";
    }
}

module("mmManagePortal").component("irFindAddArcOperatorStation", new FindAddArcOperatorStationComponent());
